import { ILogger } from "../../Commons/Logging/ILogger";
import { IValueProducer } from "../../Commons/TasksCore/BuildTask";
import { reject } from "../../../../Common/TypingUtils";
import { FormGenerator } from "../Form/GenerateForm";

import { AcquirePublishedGeneratorTask } from "./AcquirePublishedGeneratorTask";
import { BuildGeneratorFromSourcesTask } from "./BuildGeneratorFromSourcesTask";

const generatorPool: { [key: string]: IValueProducer<FormGenerator> } = {};

export type GeneratorSource =
    | {
          type: "PublishedGenerator";
          version: string;
      }
    | {
          type: "GeneratorSources";
          path: string;
      };

export function getGeneratorSourceKey(source: GeneratorSource): string {
    return source.type === "GeneratorSources" ? source.path : source.version;
}

export function generatorFactory(
    source: GeneratorSource,
    candyModulesDirectory: string,
    useVersionFromCache: boolean,
    logger?: ILogger
): IValueProducer<FormGenerator> {
    const key = getGeneratorSourceKey(source);
    if (!generatorPool[key]) {
        if (source.type === "PublishedGenerator") {
            generatorPool[key] = new AcquirePublishedGeneratorTask(
                source.version,
                candyModulesDirectory,
                useVersionFromCache,
                logger
            );
        } else {
            generatorPool[key] = new BuildGeneratorFromSourcesTask(source.path, logger).skipUpdatesUntilNextCompleted();
        }
    }
    return generatorPool[key] ?? reject();
}
